<template>
  <div class="page-content -column -column-two">
    <h3 class="section-title -mb">API Base URL</h3>
    <span class="value-box">{{ config.apiBaseUrl }}</span>

    <hr />

    <h3 class="section-title -mb">{{ currentTeam.name }} Team ID</h3>
    <span class="value-box">{{ currentTeam.hashid }}</span>

    <hr />

    <h3 class="section-title -mt -mb">Client Applications</h3>

    <span v-if="clientApplications.length === 0" class="value-box">No client applications yet</span>

    <div v-for="app in clientApplications" :key="app.name" class="client-application">
      <p><strong>Name:</strong> {{ app.name }}</p>
      <p v-for="at in app.access_tokens" :key="at.token"><strong>Access token:</strong> {{ at.token }}</p>
    </div>

    <form class="client-application-form" @submit.prevent="submitClientAppForm">
      <input v-model="newAppName" type="text" placeholder="Client Application Name" />
      
      <span v-if="errors.name" class="alert -inline -danger">
        {{ [...errors.name].join(', ') }}
      </span>
      
      <action-button
        :state="formState"
        :text="'Create Client Application'"
        @pressed="submitClientAppForm"
      ></action-button>
    </form>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

import actionButton from "@/components/actionButton";
import settingsBase from "@/components/settings/base.vue";

export default {
  components: { actionButton },
  extends: settingsBase,

  data() {
    return {
      fields: [],
      formState: "normal",
      newAppName: "",
      errors: {}
    };
  },

  computed: {
    ...mapState({
      clientApplications: (state) => state.clientApplications.all
    }),
    ...mapGetters(["currentTeam", "config"])
  },

  methods: {
    submitClientAppForm() {
      if (this.formState !== "normal") return;
      this.formState = "loading";

      this.$store
        .dispatch("createClientApplication", { name: this.newAppName })
        .then((resp) => {
          this.newAppName = "";
          this.formState = "done";
          this.errors = {};
          setTimeout(() => {
            this.formState = "normal";
          }, 2000);
        })
        .catch((err) => {
          this.errors = {...err.response.data.errors};
          console.error("Error creating application:", err);
          this.formState = "normal";
        });
    }
  }
};
</script>
